import React from 'react';
import { Tabs, Modal, Toast, Badge, Icon} from 'antd-mobile';
import {post} from '../../utils/request';

import api from './api';

import './index.less';

class yysChargingOperatorDetail extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = {
            urlOps: {},
            modalType: false,
            statictisData: {
                incomeAmount: 0
            },
            detailData: []
        };
    }

    // #/inviteNewUsers?app_stoken=xxxx&
    componentDidMount() {
        var obj = '',obj1 = '',ops={};
        if(window.location.hash.indexOf('?') > -1 ){
            obj = window.location.hash.split('?')[1];
            obj1 = obj.split('&');
            for(var i=0;i<obj1.length;i++){
                ops[obj1[i].split('=')[0]] = obj1[i].split('=')[1] === 'undefined' ? '' : obj1[i].split('=')[1];
            }
            if(ops.app_stoken === 'null' || ops.app_stoken === '(null)' || ops.app_stoken === 'undefined' || !ops.app_stoken){
                Toast.fail('请登录APP再进行操作',999);
                return;
            }
            
            this.setState({
                urlOps: ops
            },()=>{
                if(ops.app_stoken && ops.app_stoken != 'null'){
                    this.getMyChargeCarrierDetail();
                    this.getSelectInviteList();
                }
            });
        }
    }

    getMyChargeCarrierDetail(){
        const {urlOps} = this.state;
        post({
            url: api.myChargeCarrierDetail + '?app_stoken=' + urlOps.app_stoken,
            data: {}
        }).then((res) => {
            if(res.result === 'success'){
                this.setState({
                    statictisData: res.data
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取统计数据失败',1);
        });
    }

    getSelectInviteList(){
        const {urlOps} = this.state;
        post({
            url: api.selectChargeCarrierInviteIncomeByCondition + '?app_stoken=' + urlOps.app_stoken,
            data: {
                // activityCode: urlOps.activityCode,
            }
        }).then((res) => {
            if(res.result === 'success'){
                let arr = [];
                let objs = {}
                res.data.map(item => {
                    let time = item.gmtCreate.slice(0,7)
                    if(objs[time]){
                        objs[time].push(item);
                    }else{
                        objs[time] = [item];
                    }
                })

                for(var key in objs){
                    arr.push({
                        time: key,
                        list: objs[key]
                    })
                }
                
                this.setState({
                    detailData: arr
                })
            }else{
                Toast.info(res.msg,1);
            }
        }, (res)=>{
            Toast.info('获取明细失败',1);
        });
    }

    render() {
        const {modalType, statictisData, detailData} = this.state
        // const reg = /^(\d{3})\d{4}(\d{4})$/;

        // const tabs = [
        //     { title: '奖励发放', },
        //     { title: '邀请记录' },
        //   ];
        return (
            <div className="yysChargingOperatorDetailBox">
                <div className="totalAmountBox">
                    <div>
                        累计金额
                        <i onClick={()=>{
                            this.setState({
                                modalType: true
                            })
                        }}></i>
                    </div>
                    <p>{statictisData.incomeAmount}</p>
                </div>

                <div>
                    <div className="monthBox">
                        {
                            detailData.map((item,index)=>{
                                return (
                                    <div key={'riqi_'+index}>
                                        <h2>{item.time}</h2>
                                        <div>
                                            {
                                                item.list.map((obj,j)=>{
                                                    return (
                                                        <div key={'yaoqing_'+j} className="yaoqing-box">
                                                            <div className='yaoqing-left'>
                                                                <div className='phone'>被邀请人{obj.phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2")}充电</div>
                                                                <div className='grey'>{obj.gmtCreate}</div>
                                                            </div>
                                                            <div className='yaoqing-right'>
                                                                +{obj.incomeAmount}
                                                                {/* .toFixed(2) */}
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                
                    
                    {/* <div>
                        <h2>12月</h2>
                        <div className="nullData">
                            暂无明细记录
                        </div>
                    </div> */}
                    {/* <div>
                        <h2>12月</h2>
                        <div>
                            <div>
                                <div>
                                    被邀请人133****1234充值
                                </div>
                                <div>
                                    +9.00
                                </div>
                            </div>
                            <div>
                                <div>
                                    被邀请人133****1234充值
                                </div>
                                <div>
                                    +9.00
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
                {modalType ? (
                <div className="modalBox">
                    <div>
                        <div className="modalContent">
                            <h2 style={{textAlign: 'center'}}>累积返利</h2>
                            <p>返利=每笔司机结算的充电订单中的服务费金额（充电费不包括在内），根据运营商给司机设置不同桩企公司下的折扣-慧联给运营商设置的不同桩企公司下的折扣金额。</p>
                        </div>
                        <div className="modalBtn" onClick={()=>{
                            this.setState({
                                modalType: false,
                            })
                        }}>我知道了</div>
                    </div>
                </div>) : ''}
            </div>
        );
    }
};

export default yysChargingOperatorDetail;


// WEBPACK FOOTER //
// ./src/yysChargingOperator/detail/index.js